import { Switch, Route } from "react-router-dom";

import Landing from "./Pages/Landing";

import Layout from "./Components/Layout";

import Services from "./Pages/Services/Services";

import OurCompanies from "./Pages/OurCompanies";

import Gateway from "./Pages/Gateway/Gateway";

import Preloader from "./Components/Preloader/Preloader";

import Commodity from "./Pages/CommodityDesk/Commodity";

import SmartCities from "./Pages/SmartCities/SmartCities";

import About from "./Pages/About/About";

import Founder from "./Pages/About/Founder";

import Other from "./Pages/Other/Other";

import Careers from "./Pages/Careers/Careers";

import ContactUS from "./Pages/ContactUS/ContactUS";
import Shahada from "./Pages/Pillars/Shahada/Shahada";
import Prayer from "./Pages/Pillars/Prayer/Prayer";
import Zakat from "./Pages/Pillars/Zakat/Zakat";
import Fasting from "./Pages/Pillars/Fasting/Fasting";
import Hajj from "./Pages/Pillars/Hajj/Hajj";
import "./App.css";

import { useEffect, useState } from "react";

function App() {
  useEffect(() => {
    if (localStorage.getItem("Language") == "rtl") {
      document.querySelector("body").classList.add("rtl");
    }
  }, []);

  return (
    <>
      <Preloader />
      <Switch>
        <Layout>
          <Route exact path="/" component={Landing} />
          <Route path="/services" component={Services} />
          <Route path="/about-us" component={About} />
          <Route path="/founder" component={Founder} />
          <Route path="/other" component={Other} />
          <Route path="/careers" component={Careers} />
          <Route path="/our-companies" component={OurCompanies} />
          <Route path="/gateway-africa-asia" component={Gateway} />
          <Route path="/commodity-desk" component={Commodity} />
          <Route path="/smart-cities" component={SmartCities} />
          <Route path="/contact-us" component={ContactUS} />
          <Route path="/five-pillars-shahada" component={Shahada} />
          <Route path="/five-pillars-prayer" component={Prayer} />
          <Route path="/five-pillars-zakat" component={Zakat} />
          <Route path="/five-pillars-fasting" component={Fasting} />
          <Route path="/five-pillars-pilgrimage" component={Hajj} />
        </Layout>
      </Switch>
    </>
  );
}

export default App;
